import { Add } from '@mui/icons-material';
import { LoadingButton } from '@mui/lab';
import { Box, CircularProgress, Theme, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { observer } from 'mobx-react';
import React, { useEffect, useState } from 'react';
import { SSODeleteConfirmModal } from './parts/SSODeleteConfirmModal';
import { SSOProviderFormModal } from './parts/SSOProviderFormModal';
import { SSOProvidersTable } from './parts/SSOProvidersTable';
import { ISSODomain } from './store/ISSODomain';
import { SSODomain } from './store/SSODomain';

export const SSOPage = observer(() => {
  const [ssoDomain] = useState<ISSODomain>(new SSODomain());
  const classes = useStyles();

  useEffect(() => {
    ssoDomain.loadData();
  }, []);

  return (
    <Box className={classes.wrapper}>
      <Box className={classes.header}>
        <Typography sx={{ marginRight: 'auto' }} variant="h4">
          SSO провайдеры
        </Typography>
        <LoadingButton className={classes.button} variant="contained" startIcon={<Add />} color="primary" onClick={ssoDomain.openCreate}>
          Создать SSO соединение
        </LoadingButton>
      </Box>
      <Box className={classes.contentWrapper}>
        {ssoDomain.ui.isLoading.value && (
          <Box sx={{ flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <CircularProgress />
          </Box>
        )}
        <Box sx={{ flex: 1 }}>
          {!ssoDomain.ui.isLoading.value && (
            <SSOProvidersTable providersList={ssoDomain.ui.providersList.list} onEdit={ssoDomain.openEdit} onDelete={ssoDomain.openDeleteConfirm} />
          )}
          <SSOProviderFormModal
            open={ssoDomain.ui.isFormOpened.value}
            mode={ssoDomain.ui.formMode.value}
            form={ssoDomain.ui.form.value}
            errors={ssoDomain.ui.formErrors.value}
            onChange={(patch) => {
              const nextForm = { ...ssoDomain.ui.form.value, ...patch };
              ssoDomain.ui.form.setValue(nextForm);
              const prevErrors = ssoDomain.ui.formErrors.value;
              const nextErrors = { ...prevErrors };
              (Object.keys(patch) as (keyof typeof patch)[]).forEach((key) => {
                delete (nextErrors as any)[key];
              });
              ssoDomain.ui.formErrors.setValue(nextErrors);
            }}
            onSubmit={ssoDomain.submitForm}
            onCancel={ssoDomain.cancelForm}
            isLoading={ssoDomain.ui.isLoading.value}
          />
          <SSODeleteConfirmModal
            open={ssoDomain.ui.isDeleteConfirmOpened.value}
            provider={ssoDomain.ui.deletingProvider.value}
            onConfirm={ssoDomain.confirmDelete}
            onCancel={ssoDomain.cancelDelete}
          />
        </Box>
      </Box>
    </Box>
  );
});

const useStyles = makeStyles((theme: Theme) => ({
  wrapper: {
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
    height: 'calc(100vh - 48px)',
  },
  header: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
  },
  contentWrapper: {
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    minHeight: 0,
  },
  button: {
    width: 'fit-content',
    whiteSpace: 'nowrap' as const,
    height: 'fit-content',
    marginRight: '10px',
  },
}));
